/**
 * External dependencies.
 */
import Head from "next/head";
import { useRouter } from "next/router";
import SiteSchema from "components/schema-set/site-schema";
import SEO from "components/seo/seo";
import { useContext } from "react";
import classNames from "classnames";

/**
 * Internal dependencies.
 */
import Header from "components/header/header";
import Footer from "components/footer/footer";
import GlobalContext from "contexts/global";
import { getStrapiMedia } from "../utils";
import Hreflang from "blocks/hreflang/hreflang";
import { layoutMetadata } from "lib/seo-metadata";

interface LayoutProp {
  children: any;
  light?: boolean;
  notice?: boolean;
  title: string;
  desc: string;
  dark?: boolean;
  className?: string;
  FooterAlt?: boolean;
  hreflang?: boolean;
  growth?: boolean;
}

const Layout: React.FC<LayoutProp> = ({
  children,
  light,
  notice,
  title,
  desc,
  dark,
  className,
  FooterAlt,
  hreflang = true,
  growth = false,
}) => {
  const { global, data, current }: any = useContext(GlobalContext);
  const { locale } = useRouter();
  const metadata = layoutMetadata({ current, data, title, description: desc });

  return (
    <div
      className={classNames(
        "wrapper",
        growth ? "wrapper--growth" : "",
        className
      )}
    >
      <a className="skip-link" href="#main-content">{locale === "tr-tr" ? "İçeriğe geç" : locale === "nl-be" ? "Ga naar inhoud" : "Skip to content"}</a>
      <SiteSchema />
      <SEO title={metadata.title} description={metadata.description} />
      {hreflang && <Hreflang data={current || data} />}
      <Head>
        <link
          rel="icon"
          href={
            global && global.Favico?.data
              ? getStrapiMedia(global.Favico)
              : "/favicon.ico"
          }
        />
      </Head>
      <Header notice={notice} dark={growth ? light : !light} />
      <main id="main-content" tabIndex={-1} className={classNames("main", { "main--dark": dark })}>
        {children}
      </main>
      <Footer alt={FooterAlt} />
    </div>
  );
};

export default Layout;
